import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripVertical } from '@fortawesome/pro-solid-svg-icons';

import { connect } from 'react-redux';
import { reorderTasks, saveTaskOrdering } from 'bundles/apex/playbooks/config/store/playbooks/actions';

import Modal from './modal';
import DeleteTask from './delete';

import { useDrag, useDrop } from 'react-dnd';

const type = 'TASK';

export function PlaybookTask({ canRequirePlaybookTasks, task, playbook, reorderTasks, saveTaskOrdering }) {
  const [showModal, setShowModal] = useState();

  const ref = useRef(null);
  const dragRef = useRef(null);

  const [{ isDragging }, drag, preview] = useDrag({
    collect: monitor => ({ isDragging: monitor.isDragging() }),
    item: { id: task.id },
    type,
  });

  const [, drop] = useDrop({
    accept: type,
    hover(draggedTask) {
      if (task.id !== draggedTask.id) {
        reorderTasks(playbook, draggedTask.id, task);
      }
    },
    drop() {
      saveTaskOrdering(playbook, task);
    },
  });

  preview(drop(ref));
  drag(dragRef);

  return (
    <React.Fragment>
      <tr
        className="clickable"
        ref={ref}
        style={{ opacity: isDragging ? 0 : 1 }}
        onClick={() => setShowModal(true)}
      >
        <td ref={dragRef} style={{ cursor: 'grab' }}>
          <FontAwesomeIcon className="text-muted" icon={faGripVertical}/>
        </td>
        <td className="name">{task.name}</td>
        {canRequirePlaybookTasks && <td>{task.required ? 'Yes' : 'No'}</td>}
        <td>{task.requiresAttachment ? 'Yes' : 'No'}</td>
        <td>{
          task.assigneeType === 'primary_broker'
            ? 'Primary broker'
            : task.assigneeType === 'by_office'
              ? 'By Office'
              : task.assignee?.name
        }</td>
        <td>{task.dueDate}</td>
        <td width="0">
          <DeleteTask playbook={playbook} task={task}/>
        </td>
      </tr>
      {!showModal ? null :
        <Modal
          className="playbook-task-modal"
          playbook={playbook}
          task={task}
          onHide={() => setShowModal(false)}
        />
      }
    </React.Fragment>
  );
}

PlaybookTask.propTypes = {
  canRequirePlaybookTasks: PropTypes.bool,
  playbook: PropTypes.object.isRequired,
  reorderTasks: PropTypes.func.isRequired,
  saveTaskOrdering: PropTypes.func.isRequired,
  task: PropTypes.shape({
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    stage: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
};

const mapDispatchToProps = {
  reorderTasks,
  saveTaskOrdering,
};

export default connect(null, mapDispatchToProps)(PlaybookTask);
